import {
  accountDescription,
  buildEntityDescriptions,
  declareCommentaryContext,
  describeEntity,
} from '@helios/comments'
import { Account } from '@helios/generic-components'

export const externalAccountCommentary = declareCommentaryContext<Account>()({
  fields: ['accountId', 'accountName'],
  build: account => {
    const accountId = account.accountId?.toString()
    return {
      accountId,
      entityDescriptions: buildEntityDescriptions([
        describeEntity(
          'account',
          accountId,
          accountDescription({ accountName: account.accountName }),
        ),
      ]),
    }
  },
})
